export default __webpack_public_path__ + "static/media/frame_ko_sp.f5db3299.png";